import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

Sentry.init({
  dsn: 'https://cb36f21fb10e301af65727cc7cdcd804@o4511506282184704.ingest.de.sentry.io/4511506284413008',
  environment: process.env.NODE_ENV || 'production',
  enabled: true,
  sendDefaultPii: false,
  // Capture console.log/warn/error as breadcrumbs alongside errors
  integrations: [
    Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
  ],
  beforeSend(event) {
    if (event.user) delete event.user.email
    return event
  },
  tracesSampleRate: 0,
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorBoundary />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
